<template>
    <TitleBar
        :title="title"
        @left-click="$emit('cancel')"
        @right-click="$emit('outline')"
    >
        <template v-slot:leftIcon>
            <CloseIcon />
        </template>
        <template v-slot:rightIcon>
            <OutlineIcon />
        </template>

    </TitleBar>

</template>

<script>
import CloseIcon from '@mobile/components/Icons/CloseIcon.vue';
import TitleBar from '@/components/TitleBar.vue';
import OutlineIcon from '@/components/Icons/OutlineIcon.vue';

export default {
    components: { TitleBar, CloseIcon, OutlineIcon },
    props: {
        title: {
            type: String,
            required: true,
        },
        showSaveDraft: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
